import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';
import { DataService } from '../shared/common-services/data.service';
import { SharedService } from '../shared/common-services/shared.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { CommonDialogComponent } from '../shared/components';

@Component({
  selector: 'app-feature-modules',
  templateUrl: './feature-modules.component.html',
  styleUrls: ['./feature-modules.component.scss']
})
export class FeatureModulesComponent implements OnDestroy {

  @ViewChild('featuremodule') featuremodule!: ElementRef;

  headerTitle: string;
  attributeDetailsLoad: boolean = false;
  addDeviceEnable: boolean = false;
  addTemplateEnable: boolean = false;
  addDeviceDisable: boolean = false;
  addBatchDisable: boolean = false;
  addBatchEnable: boolean = false;
  deviceId: string = null;
  allTenants: boolean = true;
  addTemplate: boolean = false;
  addBatch: boolean = false;
  isEdit: boolean = false;
  isClone: boolean = false;
  batchEdit: boolean = false;

  private _dataServiceSubscription: Subscription;

  constructor(public sharedService: SharedService, private _dataService: DataService, private _router: Router, private _dialog: MatDialog) {
    this.sharedService.noPrivilegeNavigate();
    this.sharedService.getTitle.subscribe((msg: string) => {
      this.headerTitle = msg;
      const url = this._router.url.split('/');
      this.deviceId = url?.[3] ? url[3] : null;
      this.addDeviceEnable = this._router?.url === '/device-management/list' ? true : false;
      this.addTemplateEnable = this._router?.url === '/template-management/template-list' ? true : false;
      this.addBatchEnable = this._router?.url === '/batch-management/batch-management' ? true : false;
    });
    this.tenantCheck();
    this._dataServiceSubscription = this._dataService?.events?.subscribe((res: { args: any[], name: string }) => {
      if (res?.name === 'apiRefresh' || res?.name === 'tenantChanged') {
        this.tenantCheck();
      }
      if (res?.name === 'scrollTop') {
        this._scrollToTop();
      } else if (res?.name === 'attributeDetailsUpdated') {
        this.attributeDetailsLoad = true;
      } else if (res?.name === 'editOrClone') {
        this.isEdit = res?.args?.[0]?.isEdit;
        this.isClone = res?.args?.[0]?.isClone;
      } else if (res?.name === 'menuChange') {
        if(this.addTemplate || this.addBatch || this.isEdit || this.isClone || this.batchEdit) {
          this._openConfirmationPopOver('', res?.args?.[0]);
        } else {
          this._router?.navigate([res?.args?.[0]]);
          this._resetFlags();
        }
      } else if (res?.name === 'batchEdit') {
        this.batchEdit = true;
      } else if (res?.name === 'disableAddDevice') {
        this.addDeviceDisable = res?.args[0];
      } else if (res?.name === 'disableAddBatch') {
        this.addBatchDisable = res?.args[0];
      } else if (res?.name === 'switchFlags') {
        this._resetFlags();
      }
    });
    this.sharedService.fetchTokenDetials(localStorage.getItem('token'));
  }

  ngOnDestroy(): void {
    this._dataServiceSubscription.unsubscribe();
  }

  /* Redirecting to grafana */
  goToLink() {
    const url = environment?.grafanaUrl ? environment?.grafanaUrl : null;
    if (url)
      window.open(url, '_blank');
  }

  /**
   * Adds devices
   */
  addDevices() {
    this._dataService.broadcast('addNewDevice');
  }

  /**
   * Adds templates
   */
  addTemplates() {
    this.addTemplate = true;
    this._router.navigateByUrl('/template-management/template-management');
  }

  /* Create new batch */
  addBatches() {
    this.addBatch = true;
    this._router.navigateByUrl('/batch-management/add-batch');
  }

  /**
   * Backs to list
   */
  backToList(headerTitle: string) {
    this._openConfirmationPopOver(headerTitle);
  }

  /**
   * Gets header title
   * @returns  
   */
  getHeaderTitle() {
    if (this.deviceId) return 'Device Name' + ' ' + this.deviceId;
    else if (this.addTemplate) return 'Add Template';
    else if (this.isEdit) return 'Edit Template';
    else if (this.isClone) return 'Clone Template';
    else if (this.batchEdit) return 'Edit Batch';
    else return 'Add Batch';
  }

  /**
   * Opens confirmation pop over
   */
  private _openConfirmationPopOver(headerTitle?: string, navUrl?: string) {
    let msg = 'Changes if any will not be saved. Are you sure you want to exit?';
    const dialogRef = this._dialog?.open(CommonDialogComponent, {
      width: '30%',
      data: {
        message: msg,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef?.afterClosed()?.subscribe((data: boolean) => {
      if (data) {
        this._resetFlags();
        if(headerTitle){
          this._dataService?.broadcast('resetForm');
          switch (headerTitle) {
          case 'Device Management': this._router?.navigateByUrl('/device-management/list', {state: {pageNo: this.sharedService.getPageNumber('device')}});
            break;
          case 'Campaign Definitions': this._router?.navigateByUrl('/template-management/template-list', {state: {pageNo: this.sharedService.getPageNumber('template')}});
            break;
          default: this._router?.navigateByUrl('/batch-management/batch-management', {state: {pageNo: this.sharedService.getPageNumber('batch')}});
            break;
          }
        } else {
          this._router?.navigate([navUrl]);
        }
      }
    });
  }

  /**
   * Resets flags
   */
  private _resetFlags() {
    this.addTemplate = false;
    this.isClone = false;
    this.isEdit = false;
    this.addBatch = false;
    this.batchEdit = false;
  }

  /**
   * Scrolls to top
   */
  private _scrollToTop() {
    if (this.featuremodule && this.featuremodule.nativeElement) {
      this.featuremodule.nativeElement.scrollTop = 0;
    }
  }

  /**
   * Tenants check
   */
  tenantCheck() {
    const tenantId = this.sharedService?.getTenantId();
    this.allTenants = tenantId ? false : true;
  }
}
